// @flow

import type {
  PdbData,
} from '../../../types/pdb';
import type { State } from '../types';

type GlobalState = {
  pdb: State,
};

// We assume this reducer is included as 'pdb' in state
const getReducer = (state: GlobalState): State => state.pdb;

export const getPdbIds = (state: GlobalState): ?Array<string> => {
  const pdbItems = getReducer(state).items;
  return pdbItems ? Object.keys(pdbItems) : null;
};

export const getPdbItemById = (state: GlobalState, pdbId: string): PdbData => (
  getReducer(state).items[pdbId]
);

export const getActivePdbId = (state: GlobalState): ?string => {
  const pdbId = getReducer(state).activePdbId;
  if (!pdbId) {
    return null;
  }
  return pdbId;
};

export const getActivePdbItem = (state: GlobalState): ?PdbData => {
  const pdbId = getActivePdbId(state);
  if (!pdbId) {
    return null;
  }
  return getPdbItemById(state, pdbId);
};

export const getPdbItem = (state: GlobalState, pdbId: ?string = null): PdbData => {
  if (!pdbId) {
    const item = getActivePdbItem(state);
    if (!item) {
      throw Error('No active pdb item found');
    }
    return item;
  }

  const item = getPdbItemById(state, pdbId);
  if (!item) {
    throw new Error(`Couldn't find pdb item ${pdbId} in store`);
  }
  return item;
};

export const pdbItemExists = (state: GlobalState, pdbId: string) => (
  Boolean(getPdbItemById(state, pdbId))
);

export const getPdbItemsByIds = (state: GlobalState, pdbIds: Array<string>): Array<PdbData> => (
  pdbIds.map(pdbId => getPdbItemById(state, pdbId)).filter(pdbItem => Boolean(pdbItem))
);
